module.exports = __webpack_public_path__ + "img/double-arrow-left-white.e52a8042.svg";